exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-main-spk{\n    margin-top: \"20px\";\n    border-style: dotted;\n    padding: 20px;\n}\n\n.detail-total-harga{\n    text-align: right;\n    font-weight: bold;\n}", ""]);

// exports
